class SwiperMainSliderHandler extends elementorModules.frontend.handlers.Base {
  getDefaultSettings() {
      return {
          selectors: {
              container: '.swiper-box-wrapper',
              slide: '.swiper-slide',
          }
      };
  }

  getDefaultElements() {
       const selectors = this.getSettings( 'selectors' );
       var elements = {
           $mainSliderContainer: this.$element.find( selectors.container )
       };
       elements.$mainSlides = elements.$mainSliderContainer.find(selectors.slide);
       return elements;
   }

   getMainSlidesCount() {
        return this.elements.$mainSlides.length;
    }

    initMainSlider() {
        var $slider = this.elements.$mainSliderContainer,
        settings = this.getSettings();

        const selectors = this.getSettings( 'selectors' );

        if (!$slider.length) {
          return;
        }

        this.swiper = new Swiper(
            selectors.container,
            {
              effect: 'fade',
              fadeEffect: {
                crossFade: true
              },
              loop: true,
              autoHeight: true,
              parallax: true,
              speed: 500,
              a11y: {
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
              },
              keyboard: {
                enabled: true,
                onlyInViewport: false,
              },
              autoplay: {
                delay: 90000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                stopOnLastSlide: true
              },
              runCallbacksOnInit: true,
              on: {
                afterInit: function (dsb_slider) {
                  var pauseIcon = '<span class="sr">Pause</span><svg aria-hidden="true" class="e-font-icon-svg e-fas-pause" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path d="M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"></path></svg>';
                  var resumeIcon = '<span class="sr">Resume</span><svg aria-hidden="true" class="e-font-icon-svg e-fas-play" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path></svg>';
                  // Play/Pause control button
                  document.querySelectorAll('.elementor-widget-main-slider').forEach(function($thisWidget, index) {
                    var $slider = $thisWidget.querySelector('.main-slider');
                    var $swiperSliderWrapper = $slider.querySelector('.swiper-wrapper');
                    var swiperSliderWrapperId = $swiperSliderWrapper.getAttribute('id');

                    const controlBtn =  $slider.querySelector('.pause-button');
                    controlBtn.innerHTML = pauseIcon;
                    controlBtn.setAttribute('aria-controls', swiperSliderWrapperId);

                    controlBtn.addEventListener('click', function () {
                      //console.log('clicked');
                        if (this.getAttribute('aria-pressed') === 'false') {
                            dsb_slider.autoplay.stop();
                            this.innerHTML = resumeIcon;
                            this.setAttribute('aria-pressed', 'true');
                        } else {
                            dsb_slider.autoplay.start();
                            this.innerHTML = pauseIcon ;
                            this.setAttribute('aria-pressed', 'false');
                        }
                    });
                  });
                },
                init: function(sw) {
                  var currentSlide = this.realIndex + 1;
                  var currentSlideDiv = document.querySelector('.swiper-current-slide');
                  var totalSlidesDiv = document.querySelector('.swiper-numberSlides');
                  const totalSlides = sw.slides.length;
                  const countDuplicates = sw.slides.filter( el => el.classList.contains('swiper-slide-duplicate') ).length;
                  const countExcludeDuplicateSlides = totalSlides - countDuplicates;

                  //totalSlidesDiv.innerHTML = '<span>'+totalSlides+'</span>';
                  totalSlidesDiv.innerHTML = '<span>'+countExcludeDuplicateSlides+'</span>';
                  currentSlideDiv.innerHTML = '<span>'+currentSlide+'</span>';


                },
                slideChange: function (sw) {
                  var currentSlide = this.realIndex + 1;
                  var currentSlideDiv = document.querySelector('.swiper-current-slide');
                  var totalSlidesDiv = document.querySelector('.swiper-numberSlides');
                  const totalSlides = sw.slides.length;
                  const countDuplicates = sw.slides.filter( el => el.classList.contains('swiper-slide-duplicate') ).length;
                  const countExcludeDuplicateSlides = totalSlides - countDuplicates;

                  //totalSlidesDiv.innerHTML = '<span>'+totalSlides+'</span>';
                  totalSlidesDiv.innerHTML = '<span>'+countExcludeDuplicateSlides+'</span>';
                  currentSlideDiv.innerHTML = '<span>'+currentSlide+'</span>';
                },
              },
              pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
           }
        );
    }

    onInit() {
        elementorModules.frontend.handlers.Base.prototype.onInit.apply(this, arguments);
        this.initMainSlider();
    }

    onEditSettingsChange(propertyName) {
        if (1 >= this.getMainSlidesCount()) {
            return;
        }
    }
}


// When the frontend of Elementor is created, add our handler
jQuery( window ).on( 'elementor/frontend/init', () => {
    const addHandler = ( $element ) => {
        elementorFrontend.elementsHandler.addHandler( SwiperMainSliderHandler, {
            $element,
        } );
    };
    elementorFrontend.hooks.addAction( 'frontend/element_ready/main-slider.default', addHandler );
} );
